export interface FormsFormValues {
  id: string
  name: string
  type: string
  document: File | string | null
}

export const INITIAL_FORMS_VALUES: FormsFormValues = {
  id: '',
  name: '',
  type: '',
  document: null,
}

export const DOCUMENT_TYPES = [
  { value: 'pdf', label: 'PDF (.pdf)' },
  { value: 'docx', label: 'Word (.doc o .docx)' },
  { value: 'xlsx', label: 'Excel (.xls o .xlsx)' },
  { value: 'pptx', label: 'PowerPoint (.ppt o .pptx)' },
]

export const WORD_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]

export const EXCEL_MIME_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export const POWERPOINT_MIME_TYPES = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]
